webpackJsonp([1],{

/***/ "0kU0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "13jD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__("OF+h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__zotero__ = __webpack_require__("3NBv");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__zotero__["a" /* default */]],
  data: function data() {
    return {
      LibToFetch: '2083331',
      loading: true,
      totalItems: 7,
      search: '',
      pagination: {
        rowsPerPage: 10
      },
      selected: []
    };
  },
  props: ['zkey'],
  watch: {},
  created: function created() {
    var _this = this;

    this.getItem(this.LibToFetch, this.zkey).then(function (res) {
      _this.ItemData = res.data.data;
      _this.loading = false;
    });
  },

  methods: {}
});

/***/ }),

/***/ "3NBv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


var CONFIG = {
  limit: 10,
  page: 1,
  sort: 'title',
  direction: 'asc'
};
var ZOTERO = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
  baseURL: 'https://api.zotero.org/'
});

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      LibData: null,
      ItemData: null
    };
  },
  methods: {
    getItem: function getItem(library, key) {
      return ZOTERO.get('/groups/' + library + '/items/' + key, {
        params: {
          format: 'json'
        }
      });
    },
    getLibrary: function getLibrary(library, p, l, s, d) {
      var limit = l || CONFIG.limit;
      var page = p || CONFIG.page;
      var sort = s || CONFIG.sort;
      var direction = d || CONFIG.direction;
      /* eslint no-console: ["error", { allow: ["log"] }] */
      return ZOTERO.get('/groups/' + library + '/items/', {
        params: {
          limit: limit,
          start: limit * (page - 1),
          sort: sort,
          direction: direction,
          format: 'json'
        }
      });
    }
  }
});

/***/ }),

/***/ "3TcT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3XRw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_people_vue__ = __webpack_require__("Fnt4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f9b589ec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_people_vue__ = __webpack_require__("Mi6z");
function injectStyle (ssrContext) {
  __webpack_require__("aXel")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f9b589ec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_people_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f9b589ec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_people_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3p7T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_zoterotable_vue__ = __webpack_require__("GeNl");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a160e60a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_zoterotable_vue__ = __webpack_require__("RDiq");
function injectStyle (ssrContext) {
  __webpack_require__("0kU0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a160e60a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_zoterotable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a160e60a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_zoterotable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3s5o":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6nfk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7EwS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8L4C":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8Mze":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_start_vue__ = __webpack_require__("gDWM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1aa4bc9e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_start_vue__ = __webpack_require__("PrOF");
function injectStyle (ssrContext) {
  __webpack_require__("E4D0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1aa4bc9e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_start_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1aa4bc9e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_start_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8QQJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_vue__ = __webpack_require__("si2P");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8f294ef8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_vue__ = __webpack_require__("WkAX");
function injectStyle (ssrContext) {
  __webpack_require__("eGk/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8f294ef8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "90VL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9DHQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BzrI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "C76N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_zoterorecord_vue__ = __webpack_require__("13jD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_177ea834_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_zoterorecord_vue__ = __webpack_require__("gpNR");
function injectStyle (ssrContext) {
  __webpack_require__("diht")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-177ea834"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_zoterorecord_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_177ea834_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_zoterorecord_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "E4D0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FbEL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Fnt4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__("OF+h");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* default */]],
  data: function data() {
    return {
      toFetch: {
        splash: 'full\\27',
        persons: 'teaser\\?type=person',
        projects: 'teaser\\?type=project'
      },
      windowSize: {
        x: window.innerWidth,
        y: window.innerHeight - 64
      },
      loading: true
    };
  },
  mounted: function mounted() {
    this.onResize();
  },

  methods: {
    /* eslint prefer-arrow-callback: [ "error", { "allowNamedFunctions": true } ] */
    // TODO: these should be filters
    employees: function employees(type) {
      return this.persons.filter(function a(person) {
        return person.hasPosition === type;
      });
    },
    fprojects: function fprojects(person) {
      /* eslint max-len: ["error", { "code": 200 }] */
      var a = this.projects.filter(function a(project) {
        if (project.accountablePerson[0].email[0] === person) {
          return true;
        } else if (project.accountablePerson[1] && project.accountablePerson[1].email[0] === person) {
          return true;
        }
        return false;
      });
      return a;
    }
  }
});

/***/ }),

/***/ "Fx6S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_events_vue__ = __webpack_require__("OMB7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fbab003e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_events_vue__ = __webpack_require__("w59k");
function injectStyle (ssrContext) {
  __webpack_require__("yeZZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fbab003e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_events_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fbab003e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_events_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GLfK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__("OF+h");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* default */]],
  data: function data() {
    return {
      toFetch: {
        splash: 'full\\22',
        projects: 'teaser\\?type=project'
      },
      windowSize: {
        x: window.innerWidth,
        y: window.innerHeight - 64
      },
      loading: true,
      loadingCarousel: true
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.onResize();
    this.$nextTick(function () {
      setTimeout(function () {
        _this.loadingCarousel = false;
      }, 500);
    });
  },

  methods: {},
  watch: {}
});

/***/ }),

/***/ "GeNl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__("OF+h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__zotero__ = __webpack_require__("3NBv");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__zotero__["a" /* default */]],
  data: function data() {
    return {
      LibToFetch: '2083331',
      loading: true,
      totalItems: 7,
      search: '',
      pagination: {
        rowsPerPage: 10
      },
      selected: [],
      headers: [{ text: 'Author', value: 'creator' }, { text: 'Titel', align: 'left', value: 'title' }, { text: 'Datum', value: 'date' }, { text: 'Details', value: 'creator' }]
    };
  },
  watch: {
    'pagination.page': 'fetchLib',
    'pagination.rowsPerPage': 'fetchLib',
    'pagination.sortBy': 'fetchLib',
    'pagination.descending': 'fetchLib'
  },
  created: function created() {
    this.fetchLib();
  },

  methods: {
    fetchLib: function fetchLib() {
      var _this = this;

      this.loading = true;
      this.getLibrary(this.LibToFetch, this.pagination.page, this.pagination.rowsPerPage, this.pagination.sortBy, !this.pagination.descending ? 'asc' : 'desc').then(function (res) {
        _this.LibData = res.data;
        _this.loading = false;
      });
    }
  }
});

/***/ }),

/***/ "HNa/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Mi6z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('v-content',[_c('section',{staticClass:"pb-5"},[_c('v-parallax',{attrs:{"src":_vm.splash[0].banner.url,"height":"380"}},[_c('v-layout',{attrs:{"column":"","align-center":"","justify-center":""}},[_c('div',{staticClass:"layer"}),_vm._v(" "),_c('h4',{staticClass:"white--text pagecaption"},[_vm._v(_vm._s(_vm.splash[0].headline))])])],1)],1),_vm._v(" "),_c('section',{staticClass:"pt-5 pb-5"},[_c('v-container',{attrs:{"grid-list-xl":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('h4',{staticClass:"pagecaption"},[_vm._v("Leitung / Project Leader")]),_vm._v(" "),_c('hr',{staticClass:"separator"})]),_vm._v(" "),_vm._l((_vm.employees('Leitung')),function(person){return _c('v-flex',{key:person.last_name,attrs:{"xs12":"","lg6":"","xl4":"","id":'node'+person.name}},[_c('v-card',{staticClass:"elevation-5 projectcard white--text"},[_c('v-container',{attrs:{"fluid":"","grid-list-sm":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md7":""}},[_c('v-card-title',{staticStyle:{"flex-direction":"column","align-items":"flex-start"},attrs:{"primary-title":""}},[_c('div',[_c('h6',[_vm._v(_vm._s(person.firstName)+" "+_vm._s(person.lastName))])]),_vm._v(" "),_c('div',[_c('v-icon',{attrs:{"dark":""}},[_vm._v("phone")]),_vm._v(_vm._s(person.telephone))],1),_vm._v(" "),_c('a',{staticClass:"white--text",attrs:{"href":'mailto:'+person.email[0]}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("mail")]),_vm._v(" "+_vm._s(person.email[0]))],1),_vm._v(" "),(person.sameAs[0])?_c('a',{staticClass:"white--text",attrs:{"href":person.sameAs[0].url,"target":"_blank"}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("home")]),_vm._v(" "+_vm._s(person.sameAs[0].text))],1):_vm._e()])],1),_vm._v(" "),_c('v-flex',{staticClass:"pb-4 pt-4 pr-4",attrs:{"xs12":"","md4":""}},[(person.image[0])?_c('v-avatar',{attrs:{"size":"180px"}},[_c('img',{attrs:{"src":person.image[0].url,"alt":"avatar"}})]):_vm._e(),_vm._v(" "),(!person.image[0])?_c('v-avatar',{attrs:{"size":"180px"}},[_c('v-icon',{attrs:{"x-large":"","dark":""}},[_vm._v("person")])],1):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-card-text',{domProps:{"innerHTML":_vm._s(person.description)}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('h6',{staticClass:"pl-3"},[_vm._v("Projekte")]),_vm._v(" "),_c('v-list',{staticClass:"transparent",attrs:{"dark":""}},_vm._l((_vm.fprojects(person.email[0])),function(project){return _c('v-list-tile',{key:project.name,attrs:{"avatar":"","dark":"","to":{name: 'projects', params: { scrollTo: project.name }}}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(project.headline))])],1),_vm._v(" "),_c('v-list-tile-avatar',[_c('img',{attrs:{"src":project.thumbnailUrl.url}})])],1)}),1)],1)],1)],1)],1)],1)})],2)],1)],1),_vm._v(" "),_c('section',{staticClass:"pt-5 pb-5"},[_c('v-container',{attrs:{"grid-list-xl":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('h4',{staticClass:"pagecaption"},[_vm._v("MitarbeiterInnen / Researchers")]),_vm._v(" "),_c('hr',{staticClass:"separator"})]),_vm._v(" "),_vm._l((_vm.employees('Projektmitarbeiter')),function(person){return _c('v-flex',{key:person.last_name,attrs:{"xs12":"","lg6":"","xl4":"","id":'node'+person.name}},[_c('v-card',{staticClass:"elevation-5 projectcard white--text"},[_c('v-container',{attrs:{"fluid":"","grid-list-sm":"","align-content-space-between":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md7":""}},[_c('v-card-title',{staticStyle:{"flex-direction":"column","align-items":"flex-start"},attrs:{"primary-title":""}},[_c('div',[_c('h6',[_vm._v(_vm._s(person.firstName)+" "+_vm._s(person.lastName))])]),_vm._v(" "),(person.telephone)?_c('div',[_c('v-icon',{attrs:{"dark":""}},[_vm._v("phone")]),_vm._v(_vm._s(person.telephone))],1):_vm._e(),_vm._v(" "),_c('a',{staticClass:"white--text",attrs:{"href":'mailto:'+person.email[0]}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("mail")]),_vm._v(" "+_vm._s(person.email[0]))],1),_vm._v(" "),(person.sameAs[0])?_c('a',{staticClass:"white--text",attrs:{"href":person.sameAs[0].url,"target":"_blank"}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("home")]),_vm._v(" "+_vm._s(person.sameAs[0].text))],1):_vm._e()])],1),_vm._v(" "),_c('v-flex',{staticClass:"pb-4 pt-4 pr-4",attrs:{"xs12":"","md4":""}},[(person.image[0])?_c('v-avatar',{attrs:{"size":"180px"}},[_c('img',{attrs:{"src":person.image[0].url,"alt":"avatar"}})]):_vm._e(),_vm._v(" "),(!person.image[0])?_c('v-avatar',{attrs:{"size":"180px"}},[_c('v-icon',{attrs:{"x-large":"","dark":""}},[_vm._v("person")])],1):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","fill-height":""}})],1),_vm._v(" "),_c('v-layout',{attrs:{"column":""}},[_c('v-flex',[_c('v-card-text',{domProps:{"innerHTML":_vm._s(person.description)}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('h6',{staticClass:"pl-3"},[_vm._v("Projekte")]),_vm._v(" "),_c('v-list',{staticClass:"transparent",attrs:{"dark":""}},_vm._l((_vm.fprojects(person.email[0])),function(project){return _c('v-list-tile',{key:project.name,attrs:{"avatar":"","dark":"","to":{name: 'projects', params: { scrollTo: project.name }}}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(project.headline))])],1),_vm._v(" "),_c('v-list-tile-avatar',[_c('img',{attrs:{"src":project.thumbnailUrl.url}})])],1)}),1)],1)],1)],1)],1)],1)})],2)],1)],1),_vm._v(" "),_c('section',{staticClass:"pt-5 pb-5"},[_c('v-container',{attrs:{"grid-list-xl":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('h4',{staticClass:"pagecaption"},[_vm._v("Leitungsgremium / Steering Committee")]),_vm._v(" "),_c('hr',{staticClass:"separator"})]),_vm._v(" "),_vm._l((_vm.employees('Leitungsgremium')),function(person){return _c('v-flex',{key:person.last_name,attrs:{"xs12":"","lg6":"","xl4":"","id":'node'+person.name}},[_c('v-card',{staticClass:"elevation-5 projectcard white--text"},[_c('v-container',{attrs:{"fluid":"","grid-list-sm":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md7":""}},[_c('v-card-title',{staticStyle:{"flex-direction":"column","align-items":"flex-start"},attrs:{"primary-title":""}},[_c('div',[_c('h6',[_vm._v(_vm._s(person.firstName)+" "+_vm._s(person.lastName))])]),_vm._v(" "),_c('div',[_c('v-icon',{attrs:{"dark":""}},[_vm._v("phone")]),_vm._v(_vm._s(person.telephone))],1),_vm._v(" "),_c('a',{staticClass:"white--text",attrs:{"href":'mailto:'+person.email[0]}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("mail")]),_vm._v(" "+_vm._s(person.email[0]))],1),_vm._v(" "),_c('a',{staticClass:"white--text",attrs:{"href":person.sameAs[0].url}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("home")]),_vm._v(" "+_vm._s(person.sameAs[0].text))],1)])],1),_vm._v(" "),_c('v-flex',{staticClass:"pb-4 pt-4 pr-4",attrs:{"xs12":"","md4":""}},[(person.image[0])?_c('v-avatar',{attrs:{"size":"180px"}},[_c('img',{attrs:{"src":person.image[0].url,"alt":"avatar"}})]):_vm._e(),_vm._v(" "),(!person.image[0])?_c('v-avatar',{attrs:{"size":"180px"}},[_c('v-icon',{attrs:{"x-large":"","dark":""}},[_vm._v("person")])],1):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-card-text',{domProps:{"innerHTML":_vm._s(person.description)}})],1)],1)],1)],1)],1)})],2)],1)],1)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "N+IJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__("j1ja");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_axios__ = __webpack_require__("Rf8U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify_es5_components_Vuetify__ = __webpack_require__("M+UZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetify_es5_components_VApp__ = __webpack_require__("IcMm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetify_es5_components_VNavigationDrawer__ = __webpack_require__("rPQa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuetify_es5_components_VFooter__ = __webpack_require__("TWha");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuetify_es5_components_VList__ = __webpack_require__("fYhH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuetify_es5_components_VBtn__ = __webpack_require__("7Q1V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuetify_es5_components_VIcon__ = __webpack_require__("7M7f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuetify_es5_components_VGrid__ = __webpack_require__("JUsQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuetify_es5_components_VToolbar__ = __webpack_require__("+9ps");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vuetify_es5_components_VParallax__ = __webpack_require__("mLW2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vuetify_es5_components_VCard__ = __webpack_require__("f/u0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vuetify_es5_components_transitions__ = __webpack_require__("6VHA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vuetify_es5_components_VSpeedDial__ = __webpack_require__("oB7h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vuetify_es5_components_VAvatar__ = __webpack_require__("RWpw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vuetify_es5_components_VMenu__ = __webpack_require__("DBae");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vuetify_es5_components_VDataTable__ = __webpack_require__("LmeB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vuetify_es5_components_VPagination__ = __webpack_require__("8Vjh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vuetify_es5_components_VTextField__ = __webpack_require__("/yi5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vuetify_es5_components_VCarousel__ = __webpack_require__("8qgm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_carousel_3d__ = __webpack_require__("T2eB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_carousel_3d___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_vue_carousel_3d__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vue_scrollto__ = __webpack_require__("bm7V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vue_scrollto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_vue_scrollto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vue_slider_component__ = __webpack_require__("GDE4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_vue_slider_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_vue_moment__ = __webpack_require__("mjDs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_vue_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_vue_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__router__ = __webpack_require__("YaEn");































__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vuetify_es5_components_Vuetify__["a" /* default */], {
  components: {
    VApp: __WEBPACK_IMPORTED_MODULE_5_vuetify_es5_components_VApp__["a" /* default */],
    VNavigationDrawer: __WEBPACK_IMPORTED_MODULE_6_vuetify_es5_components_VNavigationDrawer__["a" /* default */],
    VFooter: __WEBPACK_IMPORTED_MODULE_7_vuetify_es5_components_VFooter__["a" /* default */],
    VList: __WEBPACK_IMPORTED_MODULE_8_vuetify_es5_components_VList__["a" /* default */],
    VBtn: __WEBPACK_IMPORTED_MODULE_9_vuetify_es5_components_VBtn__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_10_vuetify_es5_components_VIcon__["a" /* default */],
    VGrid: __WEBPACK_IMPORTED_MODULE_11_vuetify_es5_components_VGrid__["a" /* default */],
    VToolbar: __WEBPACK_IMPORTED_MODULE_12_vuetify_es5_components_VToolbar__["a" /* default */],
    VParallax: __WEBPACK_IMPORTED_MODULE_13_vuetify_es5_components_VParallax__["a" /* default */],
    VCard: __WEBPACK_IMPORTED_MODULE_14_vuetify_es5_components_VCard__["a" /* default */],
    transitions: __WEBPACK_IMPORTED_MODULE_15_vuetify_es5_components_transitions__["a" /* default */],
    VSpeedDial: __WEBPACK_IMPORTED_MODULE_16_vuetify_es5_components_VSpeedDial__["a" /* default */],
    VAvatar: __WEBPACK_IMPORTED_MODULE_17_vuetify_es5_components_VAvatar__["a" /* default */],
    VMenu: __WEBPACK_IMPORTED_MODULE_18_vuetify_es5_components_VMenu__["a" /* default */],
    VDataTable: __WEBPACK_IMPORTED_MODULE_19_vuetify_es5_components_VDataTable__["a" /* default */],
    VPagination: __WEBPACK_IMPORTED_MODULE_20_vuetify_es5_components_VPagination__["a" /* default */],
    VTextField: __WEBPACK_IMPORTED_MODULE_21_vuetify_es5_components_VTextField__["a" /* default */],
    VCarousel: __WEBPACK_IMPORTED_MODULE_22_vuetify_es5_components_VCarousel__["a" /* default */]
  } });

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_2_axios___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_23_vue_carousel_3d___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_24_vue_scrollto___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_25_vue_slider_component___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_26_vue_moment___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  router: __WEBPACK_IMPORTED_MODULE_27__router__["a" /* default */]
}).$mount('#app');

/***/ }),

/***/ "NOHZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OF+h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);



var HTTP = __WEBPACK_IMPORTED_MODULE_1_axios___default.a;

var DRUPAL = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
  baseURL: 'https://vchc-cms.univie.ac.at/',
  params: {
    _format: 'json'
  }
});

/* eslint no-param-reassign: ["error", { "props": false }] */

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['scrollTo'],
  methods: {
    get: function get(url) {
      return DRUPAL.get(url);
    },
    batchget: function batchget(entries) {
      var _this = this;

      /* eslint no-console: ["error", { allow: ["log"] }] */
      var promises = [];
      var a = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(entries);
      var idx = a.length - 1;
      while (idx > -1) {
        promises[idx] = DRUPAL.get(this.$route.params.lang + '\\' + a[idx][1]);
        idx -= 1;
      }
      return HTTP.all(promises).then(function (res) {
        var idn = a.length - 1;
        while (idn > -1) {
          _this[a[idn][0]] = _this.fixImgPath(res[idn].data);
          idn -= 1;
        }
        _this.loading = false;
      });
    },
    fixImgPath: function fixImgPath(input) {
      var idx = input.length - 1;
      while (idx > -1) {
        if (input[idx].image) {
          input[idx].image.map(function (i) {
            i.url = i.url.replace('apollo.arz', 'acdh');
            return i;
          });
        }
        if (input[idx].imagefull) {
          input[idx].imagefull.map(function (i) {
            i.url = i.url.replace('apollo.arz', 'acdh');
            return i;
          });
        }
        if (input[idx].imageteaser) {
          input[idx].imageteaser.map(function (i) {
            i.url = i.url.replace('apollo.arz', 'acdh');
            return i;
          });
        }
        idx -= 1;
      }
      return input;
    },
    goTo: function goTo(dest) {
      var el = '#node' + dest;
      this.$scrollTo(el, 1500, { offset: -50 });
    },
    onResize: function onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight - 64 };
    }
  },
  created: function created() {
    var _this2 = this;

    /* eslint no-console: ["error", { allow: ["log"] }] */
    if (this.toFetch) {
      this.batchget(this.toFetch).then(function () {
        if (_this2.scrollTo) {
          _this2.goTo(_this2.scrollTo);
        }
      });
    }
  }
});

/***/ }),

/***/ "OMB7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__("OF+h");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* default */]],
  data: function data() {
    return {
      toFetch: {
        splash: 'full\\31',
        events: 'teaser\\?type=event',
        persons: 'teaser\\?type=person'
      },
      windowSize: {
        x: window.innerWidth,
        y: window.innerHeight - 64
      },
      menu: null,
      loading: true
    };
  },
  mounted: function mounted() {
    this.onResize();
  },

  methods: {}
});

/***/ }),

/***/ "P0ba":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PJ2A":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PrOF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('v-content',[_c('section',[_c('v-parallax',{attrs:{"src":_vm.splash[0].primaryImageOfPage.url,"height":_vm.windowSize.y,"jumbotron":""}},[_c('v-layout',{staticClass:"white--text",attrs:{"column":"","align-center":"","justify-center":""}},[_c('div',{staticClass:"layer"}),_vm._v(" "),_c('v-layout',{attrs:{"column":"","align-center":"","justify-center":""},domProps:{"innerHTML":_vm._s(_vm.splash[0].mainContentOfPage)}}),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":"","color":"accent"},on:{"click":function($event){return _vm.goTo('mission')}}},[_c('v-icon',[_vm._v("expand_more")])],1)],1)],1)],1),_vm._v(" "),_c('section',{attrs:{"id":"nodemission"}},[_c('v-container',{staticClass:"mt-5 mb-5",attrs:{"grid-list-md":"","text-xs-center":""}},[_c('v-layout',{staticClass:"pt-5 pb-5",attrs:{"row":"","wrap":"","align-start":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","md6":"","lg5":""}},[_c('h2',{staticClass:"headline",domProps:{"innerHTML":_vm._s(_vm.mission[0].headline)}}),_vm._v(" "),_c('div',{attrs:{"justify-center":""}},[_c('span',{staticClass:"subheading",staticStyle:{"text-align":"left"},domProps:{"innerHTML":_vm._s(_vm.mission[0].mainContentOfPage)}})])]),_vm._v(" "),_c('v-flex',{attrs:{"xs0":"","md12":"","lg1":"","hidden-sm-and-down":""}}),_vm._v(" "),_c('v-flex',{attrs:{"lg6":"","xl4":"","hidden-sm-and-down":""}},[_c('v-layout',{attrs:{"column":"","align-center":""}},_vm._l((_vm.mission[0].imagefull),function(img,index){return _c('v-flex',{key:index},[_c('a',{attrs:{"href":img.alt,"target":"_blank"}},[_c('img',{staticStyle:{"max-width":"450px"},attrs:{"src":img.url}})])])}),1)],1)],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"my-5",attrs:{"column":"","wrap":"","align-center":""}},[_c('v-flex',{staticClass:"my-3",attrs:{"xs12":"","sm4":""}},[_c('div',{staticClass:"text-xs-center"})])],1)],1),_vm._v(" "),_c('section',[_c('v-parallax',{attrs:{"src":_vm.board[0].primaryImageOfPage.url,"height":"380"}},[_c('v-layout',{attrs:{"column":"","align-center":"","justify-center":""}},[_c('div',{staticClass:"layer"}),_vm._v(" "),_c('h4',{staticClass:"white--text pagecaption"},[_vm._v(_vm._s(_vm.board[0].headline))])])],1),_vm._v(" "),_c('v-layout',{staticClass:"my-5",attrs:{"column":"","wrap":"","align-center":""}},[_c('v-flex',{staticClass:"my-3",attrs:{"xs12":"","sm4":""}},[_c('div',{staticClass:"text-xs-center"},[_c('span',{staticClass:"subheading",domProps:{"innerHTML":_vm._s(_vm.board[0].mainContentOfPage)}})])])],1)],1)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QC22":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('v-content',[_c('section',[_c('v-parallax',{attrs:{"src":_vm.splash[0].banner.url,"height":"380"}},[_c('v-layout',{attrs:{"column":"","align-center":"","justify-center":""}},[_c('div',{staticClass:"layer"}),_vm._v(" "),_c('h4',{staticClass:"white--text pagecaption"},[_vm._v(_vm._s(_vm.splash[0].headline))])])],1),_vm._v(" "),_c('v-layout',{staticClass:"my-5",attrs:{"column":"","wrap":"","align-center":""}},[_c('v-flex',{staticClass:"my-3",attrs:{"xs12":"","sm4":""}},[_c('div',{staticClass:"text-xs-center"},[_c('span',{staticClass:"subheading",domProps:{"innerHTML":_vm._s(_vm.splash[0].mainContentOfPage)}})])]),_vm._v(" "),_c('v-flex',{attrs:{"xs10":""}},[_c('zoterotable')],1)],1)],1)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RDiq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('v-content',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.LibData,"pagination":_vm.pagination,"total-items":_vm.totalItems,"loading":_vm.loading},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [(props.item.data.creators[0].creatorType!='author')?_c('td',{staticClass:"text-xs-right"},_vm._l((props.item.data.creators),function(author,index){return _c('span',{key:index},[_vm._v(_vm._s(author.firstName)+" "+_vm._s(author.lastName)+" [ "+_vm._s(author.creatorType)+" ]/")])}),0):_vm._e(),_vm._v(" "),(props.item.data.creators[0].creatorType=='author')?_c('td',{staticClass:"text-xs-right"},[_c('span',[_vm._v(_vm._s(props.item.data.creators[0].firstName)+" "+_vm._s(props.item.data.creators[0].lastName)+" [ "+_vm._s(props.item.data.creators[0].creatorType)+" ]/")])]):_vm._e(),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.data.title))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.data.date))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_c('v-btn',{staticClass:"accent",attrs:{"dark":"","flat":"","to":{name: 'spub', params: { zkey: props.item.key } }}},[_vm._v("Details")])],1)]}}],null,false,1667394872)})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Rnfs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('v-content',[_c('section',[_c('v-parallax',{attrs:{"src":_vm.splash[0].banner.url,"height":"380"}},[_c('v-layout',{attrs:{"column":"","align-center":"","justify-center":""}},[_c('div',{staticClass:"layer"}),_vm._v(" "),_c('h4',{staticClass:"white--text pagecaption"},[_vm._v(_vm._s(_vm.splash[0].headline))])])],1),_vm._v(" "),_c('v-layout',{staticClass:"my-5",attrs:{"column":"","wrap":"","align-center":""}},[_c('v-flex',{staticClass:"my-3",attrs:{"xs12":"","sm4":""}},[_c('div',{staticClass:"text-xs-center"},[_c('span',{staticClass:"subheading",domProps:{"innerHTML":_vm._s(_vm.splash[0].mainContentOfPage)}})])])],1)],1)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RwLx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('v-content',[_c('section',[_c('v-parallax',{attrs:{"src":_vm.splash[0].banner.url,"height":"380"}},[_c('v-layout',{attrs:{"column":"","align-center":"","justify-center":""}},[_c('div',{staticClass:"layer"}),_vm._v(" "),_c('h4',{staticClass:"white--text pagecaption"},[_vm._v(_vm._s(_vm.splash[0].headline))])])],1),_vm._v(" "),_c('v-layout',{staticClass:"my-5",attrs:{"column":"","wrap":"","align-center":""}},[_c('v-flex',{staticClass:"my-3",attrs:{"xs12":"","sm4":""}},[_c('div',{staticClass:"text-xs-center"},[_c('span',{staticClass:"subheading",staticStyle:{"text-align":"left"},domProps:{"innerHTML":_vm._s(_vm.splash[0].mainContentOfPage)}})])])],1)],1)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UJfa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__("OF+h");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* default */]],
  data: function data() {
    return {
      toFetch: {
        splash: 'full\\30'
      },
      windowSize: {
        x: window.innerWidth,
        y: window.innerHeight - 64
      },
      menu: null,
      loading: true
    };
  },
  created: function created() {
    /* eslint no-console: ["error", { allow: ["log"] }] */
    this.batchget(this.toFetch);
  },
  mounted: function mounted() {
    this.onResize();
  },

  methods: {
    onResize: function onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight - 64 };
    },
    goTo: function goTo(dest) {
      var el = '#p' + dest;
      this.$scrollTo(el, 1500);
    }
  }
});

/***/ }),

/***/ "VHpS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pub_vue__ = __webpack_require__("t0AK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39002866_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pub_vue__ = __webpack_require__("QC22");
function injectStyle (ssrContext) {
  __webpack_require__("maYS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-39002866"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pub_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39002866_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pub_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Vafa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__("OF+h");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* default */]],
  data: function data() {
    return {
      toFetch: {
        splash: 'full\\29'
      },
      windowSize: {
        x: window.innerWidth,
        y: window.innerHeight - 64
      },
      menu: null,
      loading: true
    };
  },
  created: function created() {
    /* eslint no-console: ["error", { allow: ["log"] }] */
    this.batchget(this.toFetch);
  },
  mounted: function mounted() {
    this.onResize();
  },

  methods: {}
});

/***/ }),

/***/ "VscV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Wbjf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('v-content',[_c('section',{staticClass:"pb-5"},[_c('v-parallax',{attrs:{"src":_vm.splash[0].banner.url,"height":"380"}},[_c('v-layout',{attrs:{"column":"","align-center":"","justify-center":""}},[_c('div',{staticClass:"layer"}),_vm._v(" "),_c('h4',{staticClass:"white--text pagecaption"},[_vm._v(_vm._s(_vm.splash[0].headline))])])],1)],1),_vm._v(" "),_c('section',{staticClass:"pt-5 pb-5"},[_c('carousel-3d',{ref:"projectcarousel",attrs:{"width":500,"disable3d":true,"height":400,"space":600,"controls-visible":true,"controls-prev-html":'&#10092;',"controls-next-html":'&#10093;'}},_vm._l((_vm.projects),function(project,index){return _c('slide',{key:project.name,attrs:{"index":index}},[_c('v-card',{staticClass:"elevation-5 projectcard white--text"},[_c('v-layout',{staticStyle:{"height":"100%!important"},attrs:{"column":"","justify-space-between":""}},[(project.thumbnailUrl)?_c('v-card-media',{staticStyle:{"height":"200px!important"},attrs:{"src":project.thumbnailUrl.url}}):_vm._e(),_vm._v(" "),_c('v-card-title',{attrs:{"primary-title":""}},[_c('h6',[_vm._v(_vm._s(project.headline))])]),_vm._v(" "),_c('v-card-actions',{staticClass:"text-xs-right pb-4"},[_c('v-layout',{attrs:{"row":"","justify-space-between":"","align-end":""}},[_c('v-flex'),_vm._v(" "),_c('v-flex',[_c('v-btn',{staticClass:"accent",attrs:{"dark":""},on:{"click":function($event){return _vm.goTo(project.name)}}},[_vm._v("DETAILS")])],1)],1)],1)],1)],1)],1)}),1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","align-center":"","justify-center":""}},[_c('v-btn',{staticClass:"accent",attrs:{"dark":""},on:{"click":function($event){return _vm.$refs.projectcarousel.goPrev()}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("navigate_before")])],1),_vm._v(" "),_vm._l((_vm.projects),function(project,index){return (!_vm.loadingCarousel)?_c('div',{},[(index==_vm.$refs.projectcarousel.currentIndex)?_c('v-icon',[_vm._v("radio_button_checked")]):_vm._e(),_vm._v(" "),(index!=_vm.$refs.projectcarousel.currentIndex)?_c('v-icon',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.$refs.projectcarousel.goSlide(index)}}},[_vm._v("radio_button_unchecked")]):_vm._e()],1):_vm._e()}),_vm._v(" "),_c('v-btn',{staticClass:"accent",attrs:{"dark":""},on:{"click":function($event){return _vm.$refs.projectcarousel.goNext()}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("navigate_next")])],1)],2)],1),_vm._v(" "),_vm._l((_vm.projects),function(project){return _c('section',{key:project.name,staticClass:"pt-5 pb-5",attrs:{"id":'node'+project.name}},[(project.primaryImageOfPage)?_c('v-parallax',{attrs:{"src":project.primaryImageOfPage.url,"height":"380"}},[_c('v-layout',{attrs:{"column":"","align-center":"","justify-center":""}},[_c('div',{staticClass:"layer"}),_vm._v(" "),_c('h4',{staticClass:"white--text pagecaption"},[_vm._v(_vm._s(project.headline))])])],1):_vm._e(),_vm._v(" "),(!project.primaryImageOfPage)?_c('v-parallax',{attrs:{"src":_vm.splash.primaryImageOfPage.url,"height":"380"}},[_c('v-layout',{attrs:{"column":"","align-center":"","justify-center":""}},[_c('div',{staticClass:"layer"}),_vm._v(" "),_c('h4',{staticClass:"white--text pagecaption"},[_vm._v(_vm._s(project.headline))])])],1):_vm._e(),_vm._v(" "),_c('v-container',{staticClass:"mt-5 mb-5",attrs:{"grid-list-md":"","text-xs-center":""}},[_c('v-layout',{staticClass:"pt-5 pb-5",attrs:{"row":"","wrap":"","align-start":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","md6":"","lg5":""}},[_c('div',{attrs:{"justify-center":""}},[_c('span',{staticClass:"subheading",staticStyle:{"text-align":"left"},domProps:{"innerHTML":_vm._s(project.description)}})])]),_vm._v(" "),_c('v-flex',{attrs:{"xs0":"","md12":"","lg1":"","hidden-sm-and-down":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":"","lg6":"","xl4":""}},[_c('v-layout',{attrs:{"column":"","justify-space-between":""}},[_vm._l((project.accountablePerson),function(person,index){return _c('v-flex',{key:index},[_c('v-card',{staticClass:"elevation-5 projectcard white--text"},[_c('v-container',{attrs:{"fluid":"","grid-list-sm":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","lg7":""}},[_c('v-card-title',{staticStyle:{"flex-direction":"column","align-items":"flex-start"},attrs:{"primary-title":""}},[_c('div',[_c('h6',[_vm._v(_vm._s(person.first_name)+" "+_vm._s(person.last_name))])]),_vm._v(" "),(person.telephone)?_c('div',[_c('v-icon',{attrs:{"dark":""}},[_vm._v("phone")]),_vm._v(_vm._s(person.telephone))],1):_vm._e(),_vm._v(" "),_c('a',{staticClass:"white--text",attrs:{"href":'mailto:'+person.email[0]}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("mail")]),_vm._v(" "+_vm._s(person.email[0]))],1),_vm._v(" "),_c('v-btn',{staticClass:"accent",attrs:{"dark":"","to":{name: 'people', params: { scrollTo: person.id }}}},[_vm._v("DETAILS")])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"pb-4 pt-4 pr-4",attrs:{"xs12":"","lg4":""}},[(person.image)?_c('v-avatar',{attrs:{"size":"180px"}},[_c('img',{attrs:{"src":person.image[0].url,"alt":"avatar"}})]):_vm._e(),_vm._v(" "),(!person.image)?_c('v-avatar',{attrs:{"size":"180px"}},[_c('v-icon',{attrs:{"x-large":"","dark":""}},[_vm._v("person")])],1):_vm._e()],1)],1)],1)],1)],1)}),_vm._v(" "),(project.image.length > 0)?_c('v-flex',[_c('v-carousel',{attrs:{"hide-controls":"","height":"100"}},_vm._l((project.image),function(image,u){return _c('v-carousel-item',{key:u,attrs:{"src":image.url}})}),1)],1):_vm._e()],2)],1)],1)],1)],1)})],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WkAX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"light":""}},[_c('v-toolbar',{staticClass:"elevation-0 primary",attrs:{"app":"","fixed":""}},[_c('v-toolbar-title',[_c('router-link',{attrs:{"to":{ name: 'start' }}},[_c('div',{staticClass:"logo"},[_c('h5',{staticStyle:{"font-weight":"200","padding":"0px","margin":"0px","letter-spacing":"3px!important","line-height":"25px"}},[_vm._v("VIENNA CENTER FOR")]),_vm._v(" "),_c('h5',{staticStyle:{"font-weight":"800","padding":"0px","margin":"0px","letter-spacing":"2px!important","line-height":"25px"}},[_vm._v("THE HISTORY OF COLLECTING")])])])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('div',{staticClass:"text-xs-center hidden-lg-and-up"},[_c('v-menu',{attrs:{"offset-y":""}},[_c('v-btn',{staticClass:"elevation-5",attrs:{"slot":"activator","color":"accent","dark":"","icon":""},slot:"activator"},[_c('v-icon',[_vm._v("list")])],1),_vm._v(" "),(!_vm.loading)?_c('v-list',[_vm._l((_vm.items),function(item){return _c('v-list-tile',{key:item.tid[0].value,attrs:{"to":{name: item.field_path[0].value}}},[_c('v-list-tile-title',[_vm._v(_vm._s(item.name[0].value))])],1)}),_vm._v(" "),_c('div',{attrs:{"color":"white"}},[_c('v-btn',{attrs:{"small":"","fab":"","to":{ name: this.$route.name, params: { lang: 'de' }},"flat":""}},[_vm._v("\n                DE\n              ")]),_vm._v(" "),_c('span',[_vm._v("|")]),_vm._v(" "),_c('v-btn',{attrs:{"small":"","fab":"","to":{ name: this.$route.name, params: { lang: 'en' }},"flat":""}},[_vm._v("\n                EN\n              ")])],1)],2):_vm._e()],1)],1),_vm._v(" "),_c('v-toolbar-items',{staticClass:"hidden-md-and-down"},_vm._l((_vm.items),function(item){return _c('v-btn',{key:item.tid[0].value,attrs:{"color":"white","flat":"","to":{name: item.field_path[0].value}}},[_vm._v(_vm._s(item.name[0].value))])}),1),_vm._v(" "),_c('v-btn-toggle',{staticClass:"hidden-md-and-down",attrs:{"color":"white"}},[_c('v-btn',{attrs:{"small":"","fab":"","to":{ name: this.$route.name, params: { lang: 'de' }},"flat":"","color":"white"}},[_vm._v("\n          DE\n        ")]),_vm._v(" "),_c('span',{staticStyle:{"color":"white"}},[_vm._v("|")]),_vm._v(" "),_c('v-btn',{attrs:{"small":"","fab":"","to":{ name: this.$route.name, params: { lang: 'en' }},"flat":"","color":"white"}},[_vm._v("\n          EN\n        ")])],1)],1),_vm._v(" "),_c('main',[_c('v-slide-y-transition',{attrs:{"mode":"out-in"}},[_c('router-view',{attrs:{"name":"Content"}})],1)],1),_vm._v(" "),(!_vm.loading)?_c('v-footer',{staticClass:"primary",attrs:{"app":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_vm._l((_vm.footermenu),function(item){return _c('v-flex',{key:item.tid[0].value,staticClass:"text-xs-center mt-5 mb-5",attrs:{"xs12":"","md6":""}},[_c('v-btn',{attrs:{"color":"white","flat":"","to":{name: item.field_path[0].value}}},[_vm._v(_vm._s(item.name[0].value))])],1)}),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center mt-5 mb-5",attrs:{"xs12":"","md6":""}},[_c('v-btn',{attrs:{"color":"white","flat":"","href":"mailto:vchc@univie.ac.at"}},[_vm._v("KONTAKT")])],1)],2)],1)],1):_vm._e(),_vm._v(" "),(!_vm.loading)?_c('v-footer',{attrs:{"app":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.footer[0].imagefull),function(logo,index){return _c('v-flex',{key:index,staticClass:"text-xs-center mt-5 mb-5",attrs:{"xs12":"","md4":""}},[_c('img',{staticStyle:{"max-height":"200px","max-width":"200px"},attrs:{"align-center":"","src":logo.url}})])}),1)],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "X05+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XC5Q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app__ = __webpack_require__("8QQJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_start__ = __webpack_require__("8Mze");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_events__ = __webpack_require__("Fx6S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_projects__ = __webpack_require__("fYDc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_about__ = __webpack_require__("zRCK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_db__ = __webpack_require__("b74H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_people__ = __webpack_require__("3XRw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_pub__ = __webpack_require__("VHpS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_zoterorecord__ = __webpack_require__("C76N");











// import results from '@/components/searchresults';


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'root',
    redirect: function redirect(to) {
      if (to.params.lang !== '') {
        // default language german req by client, regardless of userLanguage
        // const language = window.navigator.userLanguage || window.navigator.language;
        return '/de/start';
        // return `/${language.split('-')[0]}`;
      }
      return to.fullPath;
    }
  }, {
    path: '/:lang',
    components: {
      default: __WEBPACK_IMPORTED_MODULE_2__components_app__["a" /* default */]
    },
    // Children to the root path '/'
    children: [{
      path: 'start',
      name: 'start',
      components: {
        Content: __WEBPACK_IMPORTED_MODULE_3__components_start__["a" /* default */]
      }
    }, {
      path: 'events',
      name: 'events',
      components: {
        Content: __WEBPACK_IMPORTED_MODULE_4__components_events__["a" /* default */]
      }
    }, {
      path: 'projects',
      name: 'projects',
      components: {
        Content: __WEBPACK_IMPORTED_MODULE_5__components_projects__["a" /* default */]
      },
      props: {
        Content: true
      }
    }, {
      path: 'imprint',
      name: 'imprint',
      components: {
        Content: __WEBPACK_IMPORTED_MODULE_6__components_about__["a" /* default */]
      }
    }, {
      path: 'db',
      name: 'db',
      components: {
        Content: __WEBPACK_IMPORTED_MODULE_7__components_db__["a" /* default */]
      }
    }, {
      path: 'people',
      name: 'people',
      components: {
        Content: __WEBPACK_IMPORTED_MODULE_8__components_people__["a" /* default */]
      },
      props: {
        Content: true
      }
    }, {
      path: 'pub',
      name: 'pub',
      components: {
        Content: __WEBPACK_IMPORTED_MODULE_9__components_pub__["a" /* default */]
      }
    }, {
      path: 'spub/:zkey',
      name: 'spub',
      components: {
        Content: __WEBPACK_IMPORTED_MODULE_10__components_zoterorecord__["a" /* default */]
      },
      props: { Content: true }
    },
    // {
    //   path: 'search/:searchstring',
    //   name: 'search',
    //   components: {
    //     Content: results,
    //   },
    // },
    {
      path: '',
      redirect: '/en/start'
    }, {
      path: '*',
      redirect: 'start'
    }]
  }]
}));

/***/ }),

/***/ "aXel":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "acBN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "b74H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_db_vue__ = __webpack_require__("Vafa");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ab0bbab_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_db_vue__ = __webpack_require__("RwLx");
function injectStyle (ssrContext) {
  __webpack_require__("3s5o")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6ab0bbab"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_db_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ab0bbab_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_db_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "d/lB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "diht":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eGk/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fYDc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_projects_vue__ = __webpack_require__("GLfK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2088f164_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_projects_vue__ = __webpack_require__("Wbjf");
function injectStyle (ssrContext) {
  __webpack_require__("8L4C")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2088f164"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_projects_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2088f164_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_projects_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gDWM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__("OF+h");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* default */]],
  data: function data() {
    return {
      toFetch: {
        mission: 'full\\9',
        splash: 'full\\10',
        board: 'full\\11'
      },
      windowSize: {
        x: window.innerWidth,
        y: window.innerHeight - 64
      },
      loading: true
    };
  },
  mounted: function mounted() {
    this.onResize();
  },

  methods: {}
});

/***/ }),

/***/ "gpNR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('v-content',[_c('section',{attrs:{"id":"nodemission"}},[_c('v-container',{staticClass:"mt-5 mb-5",attrs:{"grid-list-md":"","text-xs-center":""}},[_c('v-layout',{staticClass:"pt-5 pb-5",attrs:{"row":"","wrap":"","align-start":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","md9":"","lg7":""}},[_c('h2',{staticClass:"headline"},[_vm._v(_vm._s(_vm.ItemData.title))]),_vm._v(" "),_c('div',{attrs:{"justify-center":""}},[_c('v-list',{staticClass:"elevation-1",attrs:{"two-line":""}},[_vm._l((_vm.ItemData.creators),function(Author,index){return _c('v-list-tile',{key:index,attrs:{"avatar":""}},[_c('v-list-tile-avatar',[_c('v-icon',{staticClass:"grey lighten-1 white--text"},[_vm._v("person")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(Author.creatorType))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(Author.firstName)+" "+_vm._s(Author.lastName))])],1)],1)}),_vm._v(" "),_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-avatar',[_c('v-icon',{staticClass:"grey lighten-1 white--text"},[_vm._v("access_time")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Erschienen")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.ItemData.date)+" "+_vm._s(_vm.ItemData.place))])],1)],1),_vm._v(" "),(_vm.ItemData.itemType != 'book')?_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-avatar',[_c('v-icon',{staticClass:"grey lighten-1 white--text"},[_vm._v("book")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Enthalten in")]),_vm._v(" "),(_vm.ItemData.itemType == 'journalArticle')?_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.ItemData.publicationTitle)+", "+_vm._s(_vm.ItemData.pages))]):_vm._e(),_vm._v(" "),(_vm.ItemData.itemType == 'bookSection')?_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.ItemData.bookTitle)+", "+_vm._s(_vm.ItemData.volume)+" ,"+_vm._s(_vm.ItemData.pages))]):_vm._e()],1)],1):_vm._e()],2),_vm._v(" "),_c('v-btn',{staticClass:"accent",attrs:{"dark":"","flat":"","href":("https://api.zotero.org/groups/2083331/items/" + (_vm.ItemData.key) + "?format=bib"),"target":"_blank"}},[_vm._v("Zitation")]),_vm._v(" "),_c('v-btn',{staticClass:"accent",attrs:{"dark":"","flat":"","href":("https://api.zotero.org/groups/2083331/items/" + (_vm.ItemData.key) + "?format=ris"),"target":"_blank"}},[_vm._v("Export(RIS)")]),_vm._v(" "),_c('v-btn',{staticClass:"accent",attrs:{"dark":"","flat":"","href":("https://api.zotero.org/groups/2083331/items/" + (_vm.ItemData.key) + "?format=bibtex"),"target":"_blank"}},[_vm._v("Export(BibTeX)")])],1)]),_vm._v(" "),_c('v-flex',{attrs:{"xs0":"","md12":"","lg1":"","hidden-sm-and-down":""}}),_vm._v(" "),_c('v-flex',{attrs:{"lg6":"","xl4":"","hidden-sm-and-down":""}},[_c('v-layout',{attrs:{"column":"","align-center":""}})],1)],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"my-5",attrs:{"column":"","wrap":"","align-center":""}},[_c('v-flex',{staticClass:"my-3",attrs:{"xs12":"","sm4":""}},[_c('div',{staticClass:"text-xs-center"})])],1)],1)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jQdp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kP4z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kVeV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mFvD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "maYS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pu2v":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "q/9b":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qRVk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sBiC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "si2P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__("OF+h");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  /* eslint no-console: ["error", { allow: ["log"] }] */
  mixins: [__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* default */]],
  data: function data() {
    return {
      toFetch: {
        footer: 'full\\50',
        footermenu: 'menu?vid=footer',
        items: 'menu?vid=menu'
      },
      searchstring: '',
      items: null,
      loading: true
    };
  },
  watch: {
    // reload data if language is swapped
    $route: function $route(to, from) {
      if (to.params.lang !== from.params.lang) {
        location.reload();
      }
    }
  },
  methods: {
    searchfunc: function searchfunc(term) {
      this.$router.push({ name: 'search', params: { searchstring: term.target.value } });
    }
  },
  route: {
    canReuse: false
  }
});

/***/ }),

/***/ "t0AK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__("OF+h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_zoterotable__ = __webpack_require__("3p7T");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* default */]],
  components: {
    zoterotable: __WEBPACK_IMPORTED_MODULE_1__components_zoterotable__["a" /* default */]
  },
  data: function data() {
    return {
      toFetch: {
        splash: 'full\\28'
      },
      windowSize: {
        x: window.innerWidth,
        y: window.innerHeight - 64
      },
      menu: null,
      loading: true
    };
  },
  created: function created() {
    /* eslint no-console: ["error", { allow: ["log"] }] */
    this.batchget(this.toFetch);
  },
  mounted: function mounted() {
    this.onResize();
  }
});

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-ps": "zWlr",
	"./ar-ps.js": "zWlr",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn-bd": "1C9R",
	"./bn-bd.js": "1C9R",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-in": "yJfC",
	"./en-in.js": "yJfC",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./en-sg": "NYST",
	"./en-sg.js": "NYST",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-mx": "USNP",
	"./es-mx.js": "USNP",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fil": "rMbQ",
	"./fil.js": "rMbQ",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-deva": "VGQH",
	"./gom-deva.js": "VGQH",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku-kmr": "2ukb",
	"./ku-kmr.js": "2ukb",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./oc-lnc": "KOFO",
	"./oc-lnc.js": "KOFO",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tk": "+WRH",
	"./tk.js": "+WRH",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-mo": "+WA1",
	"./zh-mo.js": "+WA1",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "w59k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('v-content',[_c('section',[_c('v-parallax',{attrs:{"src":_vm.splash[0].banner.url,"height":"380"}},[_c('v-layout',{attrs:{"column":"","align-center":"","justify-center":""}},[_c('div',{staticClass:"layer"}),_vm._v(" "),_c('h4',{staticClass:"white--text pagecaption"},[_vm._v(_vm._s(_vm.splash[0].headline))])])],1),_vm._v(" "),_c('v-layout',{staticClass:"my-5",attrs:{"column":"","wrap":"","align-center":""}},[_c('v-flex',{staticClass:"my-3",attrs:{"xs12":"","sm4":""}},[_c('div',{staticClass:"text-xs-center"},[_c('span',{staticClass:"subheading",domProps:{"innerHTML":_vm._s(_vm.splash[0].mainContentOfPage)}})])])],1)],1),_vm._v(" "),_c('section',{staticClass:"pt-5 pb-5"},[_c('v-container',{attrs:{"grid-list-xl":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.events),function(event){return _c('v-flex',{key:event.name,attrs:{"xs12":"","lg6":"","xl4":""}},[_c('v-card',{staticClass:"elevation-5 projectcard white--text"},[_c('v-layout',{staticStyle:{"height":"100%!important"},attrs:{"column":"","justify-space-between":""}},[(event.thumbnailUrl)?_c('v-card-media',{staticStyle:{"height":"200px!important"},attrs:{"src":event.thumbnailUrl.url}}):_vm._e(),_vm._v(" "),_c('v-card-title',{attrs:{"primary-title":""}},[_c('h6',[_vm._v(_vm._s(event.headline))]),_vm._v(" "),_c('div',[_c('v-icon',{attrs:{"dark":""}},[_vm._v("event")]),_vm._v(" "+_vm._s(_vm._f("moment")(_vm._f("")(event.startDate),"dddd, Do MMM YYYY, h:mm a"))+" - "+_vm._s(_vm._f("moment")(event.endDate,"dddd, Do MMM YYYY, h:mm a")))],1),_vm._v(" "),_c('div',[_c('v-icon',{attrs:{"dark":""}},[_vm._v("place")]),_vm._v(" "+_vm._s(event.location))],1)]),_vm._v(" "),_c('v-card-text',{domProps:{"innerHTML":_vm._s(event.description)}}),_vm._v(" "),_c('v-card-actions',{staticClass:"text-xs-right pb-4"},[_c('v-layout',{attrs:{"row":"","justify-space-around":""}},[_c('v-flex',{attrs:{"xs10":""}},_vm._l((event.workFeatured),function(download,index){return _c('v-btn',{key:index,staticClass:"accent",attrs:{"dark":"","href":download.url,"target":"_blank"}},[_vm._v(_vm._s(download.description))])}),1)],1)],1)],1)],1)],1)}),1)],1)],1)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yeZZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zRCK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_about_vue__ = __webpack_require__("UJfa");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d02e552_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_about_vue__ = __webpack_require__("Rnfs");
function injectStyle (ssrContext) {
  __webpack_require__("mFvD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5d02e552"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_about_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d02e552_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_about_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zegt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.6d0ddf20d2ef9caf304f.js